import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { fullName, getUserInitials } from '~/infra/utils';
import { UserRole } from './UserInfoModel';
export class MemberModel {
    id() {
        return this.dto.id;
    }
    firstName() {
        return this.dto.firstName;
    }
    lastName() {
        return this.dto.lastName;
    }
    fullName() {
        return fullName(this.dto.firstName, this.dto.lastName);
    }
    email() {
        return this.dto.email;
    }
    initials() {
        return getUserInitials(this.dto);
    }
    role() {
        return this.dto.role;
    }
    invitedRole() {
        return this.dto.invitedRole;
    }
    effectiveRole() {
        return this.dto.role === 'invited' ? this.dto.invitedRole : this.dto.role;
    }
    isOwner() {
        return this.dto.role === UserRole.Owner;
    }
    isInvited() {
        return this.dto.role === 'invited';
    }
    isAssignable(isVendor) {
        return this.dto.role !== 'invited' && (isVendor || this.dto.role !== UserRole.Member);
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        this.dto = dto;
    }
}
